<template lang="pug">
.container
  div
    router-link(to="/upload") X
  .table-responsive
    table.table
      thead
        tr
          th(scope='col').border-top-0.px-0 訂單日期
          th(scope='col').border-top-0.px-0 訂單編號
          th(scope='col').border-top-0.px-0 商品名稱
          th(scope='col').border-top-0.px-0 預覽
          th(scope='col').border-top-0.px-0 上傳
      tbody
        tr(v-for="item in orderAry")
          th(scope='row') {{item.orderdate}}
          td {{item.ordernumber}}
          td
          td
            button(type="button" data-toggle="modal" data-target="#overview").btn.btn-primary <i class="fa-solid fa-cloud-arrow-up"></i>
            div(id="overview", tabindex="-1"
              role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
              div.modal-dialog(role="document").modal-lg
                div.modal-content
                  div.modal-header
                    h5.modal-title(id="exampleModalLabel") 預覽
                    button(type="button", data-dismiss="modal", aria-label="Close").close
                        span(aria-hidden="true") &times;
                  div.modal-body.text-center
                    div
                      pdfOverview
          td
            button(type="button" data-toggle="modal" data-target="#exampleModal").btn.btn-primary <i class="fa-solid fa-cloud-arrow-up"></i>
      div(id="exampleModal", tabindex="-1"
        role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
        div.modal-dialog(role="document").modal-lg
          div.modal-content
            div.modal-header
              h5.modal-title(id="exampleModalLabel") 上傳區
              button(type="button", data-dismiss="modal", aria-label="Close").close
                  span(aria-hidden="true") &times;
            div.modal-body.text-center
              div
                vue-dropzone(ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-sending="sendingEvent")
                div.d-flex.justify-content-between
                  button(type="button" @click="removeAllFiles").btn.btn-primary X 移除所有檔案
                  button(type="button" @click="processQueue").btn.btn-primary <i class="fa-solid fa-cloud-arrow-up"></i>上傳檔案

    </template>

<script>
import {mapActions, mapState} from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import pdf from 'vue-pdf'
import pdfOverview from '../components/pdfOverview.vue'

const { mapFields } = createHelpers({
  getterType: 'orderSearchModules/getField',
  mutationType: 'orderSearchModules/updateField'
})
export default{
  data () {
    return {
      fullWidth: document.body.clientWidth,
      dropzoneOptions: {
        url: 'https://staging-www.cloudw2p.com/api/v1/pdfwkflow/multiuploads',
        acceptedFiles: 'application/pdf',
        maxFilesize: 40, // 檔案大小上限
        thumbnailWidth: 50,
        addRemoveLinks: true, // 新增移除按鈕
        duplicateCheck: true, // 重複檢查
        autoProcessQueue: false // 停止自動上傳
      }
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    pdf,
    pdfOverview
  },
  computed: {
    ...mapFields(['startDate', 'endDate']),
    ...mapState('orderSearchModules', ['orderAry'])
  },
  methods: {
    ...mapActions('orderSearchModules', ['getOrder', 'init']),
    removeAllFiles () {
      this.$refs.myVueDropzone.removeAllFiles()
    },
    processQueue () {
      this.$refs.myVueDropzone.processQueue()
    },
    sendingEvent (file, xhr, formData) {
      formData.append('path', '1')
      formData.append('name', `${file.name}`)
      console.log(file)
    }
  },
  created () {
    let vm = this
    vm.init()
  }
}
</script>

    <style lang="scss" scoped>
    .title{
      font-size: 24px;
      font-weight: bold;
      font-family: "Noto Serif TC",serif;
    }
    .searchBtn{
      flex-shrink: 0;
    }

    @media(min-width: 640px) {
      .searchBarContent{
        display:flex;
        justify-content:center;
        align-items:center;
        input[type="date"]{
          margin:0 8px;
        }
      }
    }
    @media(max-width: 641px) {
      .searchBarContent{
        display:flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        input[type="date"]{
          margin:0 0 8px;
        }
      }
    }

    th,td{
      vertical-align: middle;
      text-align: center;
    }
    .dropzone-custom-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }

    .dropzone-custom-title {
      margin-top: 0;
      color: #00b782;
    }
    .subtitle {
      color: #314b5f;
    }
    </style>



// WEBPACK FOOTER //
// src/components/orderContent.vue